import React, { useCallback, useEffect, useMemo, useState } from "react";
import { ArrowLeft } from 'react-feather'
import { Modal, Tabs, Tab, Container, Row, Col, Form, Button } from "react-bootstrap"
import DataDisplayTable from "../../../dataDisplayTable";

const cols = [
  { accessor: 'idx', show: false },
  { accessor: 'stack', show: false },
  { Header: "Error", accessor: 'error', Cell: (data) => <div>{data.value ? data.value.slice(0, 25) + '...' : 'No Error'}</div> },
  { Header: 'Action Type', accessor: 'action_type' },
  { Header: 'Control', accessor: 'control_name' },
  { Header: 'Client Start', accessor: 'client_start_time', Cell: getDateForTableCell },
  { Header: 'Server Start', accessor: 'server_start_time', Cell: getDateForTableCell },
  { Header: 'Server Completed', accessor: 'server_completed_time', Cell: getDateForTableCell },
  { Header: 'Client Completed', accessor: 'client_completed_time', Cell: getDateForTableCell },
]
function getDateForTableCell(data) {
  return data.value && new Date(data.value).toLocaleString()
}

function mapConfirmations(confirmations) {
  return !confirmations.length ? [] : confirmations.map((itm, idx) => ({
    idx: `${idx}`,
    error: itm.error && itm.error.message,
    stack: itm.error && itm.error.stack,
    action_type: itm.action.action_type,
    control_name: itm.action.control_name,
    client_start_time: itm.action.client_start_time,
    server_start_time: itm.action.server_start_time,
    server_completed_time: itm.action.server_completed_time,
    client_completed_time: itm.action.client_completed_time
  }))

}
export function ConfirmationViewerModal({ show, setShow, confirmationHistory }) {

  const [activeConfirmation, setActiveConfirmation] = useState(false)
  const [activeTab, setActiveTab] = useState('errors')

  const formattedErrors = useMemo(() => mapConfirmations(confirmationHistory.errors), [confirmationHistory.errors])
  const formattedHistory = useMemo(() => mapConfirmations(confirmationHistory.history), [confirmationHistory.history])

  const handleRowClick = useCallback((data) => { setActiveConfirmation(data.idx) },)
  useEffect(()=>{
    if (!show){
      setActiveConfirmation(false)
      setActiveTab('errors')
    }
  }, [show])
  return (
    <Modal
      show={show}
      style={{zIndex:99999}}
      onHide={() => setShow(false)}
      size="xl"
      scrollable>
      <Modal.Header>
        {!activeConfirmation ? [] : (
          <Button
            variant="outline-light"
            onClick={() => setActiveConfirmation(false)}
          >
            <ArrowLeft size="20" style={{color:'grey'}} />
            Back
          </Button>
        )}
        <Modal.Title style={{marginLeft:10}}>Viewing Errors and Confirmation History</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!activeConfirmation ? (
          <Tabs
            fill
            defaultActiveTab="errors"
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
          >
            <Tab eventKey="errors" title="Errors">
              {!formattedErrors.length ? "No Errors..." : (
                <DataDisplayTable
                  data={formattedErrors}
                  cols={cols}
                  onClickEntry={handleRowClick} />
              )}
            </Tab>
            <Tab eventKey="history" title="Full History">
              {!formattedHistory.length ? "No History yet..." : (
                <DataDisplayTable
                  data={formattedHistory}
                  cols={cols}
                  onClickEntry={handleRowClick} />
              )}
            </Tab>
          </Tabs>
        ) : (
          <ConfirmationDisplayForm confirmation={confirmationHistory[activeTab][activeConfirmation]} onHide={() => setActiveConfirmation(false)} />
        )}
      </Modal.Body>
    </Modal>
  )
}

function ConfirmationDisplayForm({ confirmation, onHide }) {
  console.log('rendering ConfirmationDisplayForm', confirmation)
  let rows = Object.keys(confirmation).map(itm => {
    return (
      <Row>
        <Form.Label column sm="2">{itm}</Form.Label>
        <Col sm="10">
          <pre>
            {JSON.stringify(confirmation[itm], null, 2).replace(/(^|[^\\])(\\\\)*\\n/g, (m) => {
              return m.replace(/\\n/, "\n");
            })}
          </pre>
        </Col>
      </Row>
    )
  })
  return (
    <Container>
      {rows}
    </Container>
  )
}
